a.reservation.shared = (function(){
	var my = {
		markCompleted:function(rid,cb_success,cb_error){
			a.loader.fs.create();
			$.ajax({
				type:'POST',
				url:'/api/reservation/mark_completed/',
				data:{
					rid:rid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						cb_success();
					}
					else {
						cb_error();
					}
				}
			}).done(function(){
				a.loader.fs.remove();
			});
		},
		resetValErr:function(token){
			var form = $('#popupid_'+token+' form[name="new_reservation"]');
			// Remove errors
			$('*',form).removeClass('valerr');
			$('[data-areatype="error"]',form).hide();
		},
		validateForm:function(token,form){
			var win = $('#popupid_'+token);
			var val = true;
			if ($('input[name="name"]',form).val().length<3) {
				val = false;
			}
			if ($('input[name="iid[]"]',form).length==0) {
				val = false;
			}
			if (val) {
				$('button[data-action="complete"]',win).prop('disabled',false);
			}
			else {
				$('button[data-action="complete"]',win).prop('disabled',true);
			}
		}
	}
	return my;
}());